import axios from 'axios';
import { appApiUrl } from './appApiOrigin';
import { invalidateSessionCache } from './sessionAuth';
import { clearUserData } from '../newsintelligence/DataCache/userData';
import { clearProfileIdentity } from '../newsintelligence/DataCache/profileIdentity';
import { clearAllDiscussionClientCaches } from '../newsintelligence/support/openDiscussions';

/** Clear server session cookie (even if JWT is expired) and all in-memory client auth caches. */
export async function performClientSignOut() {
  try {
    await axios.post(appApiUrl('/api/signout'), {}, { withCredentials: true, timeout: 15_000 });
  } catch {
    /* cookie may already be invalid; server still clears when reachable */
  }
  invalidateSessionCache();
  clearUserData();
  clearProfileIdentity();
  try {
    clearAllDiscussionClientCaches();
  } catch {
    /* ignore */
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('bahlus-session-ended'));
  }
}
